module.exports = __webpack_public_path__ + "img/kalium-appstore.d333e94b.svg";